import { apiService } from './api';

/**
 * Service for handling Automation Flows (Chatbot Builder) API calls
 */
export const automationFlowsService = {
  /**
   * Create a new flow
   * @param {Object} flowData - The flow data
   * @returns {Promise<Object>} The created flow
   */
  createFlow: async flowData => {
    return await apiService.post('/automation-flows', flowData);
  },

  /**
   * Get all flows for a project
   * @param {string} projectId - The ID of the project
   * @param {Object} params - Query parameters (page, limit, search, isActive)
   * @returns {Promise<Object>} Paginated list of flows
   */
  getFlows: async (projectId, params = {}) => {
    const queryParams = new URLSearchParams({
      projectId,
      ...params,
    }).toString();
    return await apiService.get(`/automation-flows?${queryParams}`);
  },

  /**
   * Get a flow by ID
   * @param {string} flowId - The ID of the flow
   * @param {string} projectId - The ID of the project
   * @returns {Promise<Object>} The flow object
   */
  getFlowById: async (flowId, projectId) => {
    const queryParams = new URLSearchParams({ projectId }).toString();
    return await apiService.get(`/automation-flows/${flowId}?${queryParams}`);
  },

  /**
   * Update a flow
   * @param {string} flowId - The ID of the flow
   * @param {Object} flowData - The updated flow data (must include projectId)
   * @returns {Promise<Object>} The updated flow
   */
  updateFlow: async (flowId, flowData) => {
    return await apiService.put(`/automation-flows/${flowId}`, flowData);
  },

  /**
   * Delete a flow
   * @param {string} flowId - The ID of the flow
   * @param {string} projectId - The ID of the project
   * @returns {Promise<Object>} Deletion result
   */
  deleteFlow: async (flowId, projectId) => {
    const queryParams = new URLSearchParams({ projectId }).toString();
    return await apiService.delete(
      `/automation-flows/${flowId}?${queryParams}`
    );
  },
};

export default automationFlowsService;
